var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-wrapper"},[_c('head-view')],1),_c('div',{staticClass:"page-content"},[_c('home-view')],1),_c('process-view',{attrs:{"appList":_vm.appGameData,"tapList":_vm.tapGameData}}),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }